<template>
  <div class="bg-light private_job" style="margin-top: 80px;">
    <div class="col-md-12 p-0" v-if="jobDetails&&jobDetails.header_img">
        <img :src="$S3_bucket_url+jobDetails.header_img" alt="" style="width:100%">
    </div>
    <div class="title">
      <div class="container">
        <div class="col text-center mt-3">
          <marquee style="color:red;font-weight:bold;font-size:18px" v-if="expired">Applications for this recruitment are closed now.</marquee>
          <marquee style="color:red;font-weight:bold;font-size:18px" v-if="jobDetails&&jobDetails.marquee_text&&jobDetails.marquee_text.length&&!expired">{{jobDetails.marquee_text}}</marquee>
          <h1 class="mb-3" style="color: #24448f;font-weight: bold;" v-if="job&&job.job_designation">Job Title : {{job.job_designation}}</h1>
        </div>
      </div>
    </div>
    <div>
      <div class="container">
        <div class="row">
          <div class="col-md-8 mt-3">
            <p class="text-left" v-if="jobrole"><b class="subhead">Job Role : {{jobrole.role}}</b> </p>
            <p class="text-left" v-if="job&&job.salary_range_from"><b class="subhead">CTC Offered : <span>{{job.salary_range_from}}</span><span v-if="job.salary_range_to"> - {{job.salary_range_to}}</span></b> </p>
            <p class="text-left"><b class="subhead">Eligibility Criteria :</b></p>
            <ul>
              <li><span v-if="job&&job.courses"><span v-for="(course,index) in job.courses" :key="index">{{ course.name }}</span></span><span v-if="job&&job.year_of_passing_from">with year of passing {{job.year_of_passing_from}}<span v-if="job&&job.year_of_passing_to"> - {{job.year_of_passing_to}}</span></span></li>
              <li v-if="job&&job.hq_marks_percentage_from">Candidate should have scored minimum {{job.hq_marks_percentage_from}}% in Graduation, 12 th &amp; 10 th</li>
              <li v-if="job&&job.skills&&job.skills.length">Skills: <span v-for="(skill , index) in job.skills" :key="index">{{skill}}<span v-if="job.skills.length != index+1">,</span></span></li>
              <!-- <li>Candidate should not have any backlogs.</li> -->
            </ul>
            <p></p>
            <p class="text-left" v-if="job&&job.hiring_process"><b class="subhead">Selection Process : {{job.hiring_process}}</b> </p>
            <p class="text-left" v-if="cities&&cities.length"><b class="subhead">Job Location : <span v-for="(city, itemObjKey) in cities" :key="city.city_id">{{ city.city_name}}<span v-if="cities.length != itemObjKey + 1">,</span></span></b> </p>
            <p class="text-left" v-if="job&&job.job_desc_pdf"><b class="subhead">Job Description : </b><span><a :href="$S3_bucket_url+job.job_desc_pdf" target="_blank">Click here </a>to view detailed job description</span></p>
            <p  v-if="jobDetails.job_desc_pdf"><b>Job Description :</b> <a :href="$S3_bucket_url+jobDetails.job_desc_pdf">Click here</a> to view detailed job description</p>
          </div>
          <div class="col-md-4" v-if="jobDetails&&jobDetails.job_video">
            <video style="width:100%;bottom:0;margin-top:10px;width:410px;" controls="">
              <source :src="$S3_bucket_url+jobDetails.job_video" type="video/mp4">
            </video>
          </div>
        </div>
      </div>
    </div>
    <section class="applynow" v-if="job">
      <div class="">
        <div class="row ">
          <div class="col-sm text-center">
            <a class="btn btn-success text-white" target="_blank" style="font-size: 20px;" :href="vue_app_url + 'form/'+job.job_id">Apply now</a>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm text-center">
            <p class="text-center">Looking forward to your joining our Family !!!</p>
          </div>
        </div>
      </div>
    </section>
    <section  v-if="job&&job.job_description">
      <div class="container">
        <div class="row p-3">
          <div class="col-md-12">
            <div style="text-align: justify;" v-html="job.job_description"></div>
          </div>
        </div>
      </div>
    </section>
    <section>
        <div class="container">
            <div class="col text-center mt-5">
                <p><small><a href="/">Hireclap.com</a> is the largest video resume-based job site in India. We publish job opportunities on behalf of hiring companies to share job openings with job seekers. The recruitment process will be conducted directly by the hiring companies. Please ensure that you review the job descriptions and eligibility criteria  before applying. Hireclap does not charge any fees for job offers. We strongly advise you to be cautious and beware of job offer scams.</small></p>
            </div>
        </div>
    </section>
    <section>
      <div class="row">
        <!--footer-->
        <div class="col" style="background-color: #b6b5b5;">
          <div class="container">
            <div class="row ">
              <div class="col-lg-5 alignmob">
                <!-- <p class="content-center" style="color: #fff;padding: 10px">© 2022 <a class="flink" style="color: white" href="">Hireclap</a> | Hire best matching candidates</p> -->
                <p class="content-center">© 2023 <a class="flink" target="_blank" href="https://www.hireclap.com/"><img height="50px" src="https://s3.ap-south-1.amazonaws.com/www.hireclap.com/Assets/images/hireclap-logo-HD.png" alt="Hireclap" title="Hireclap | Hire best matching candidates"></a></p>
              </div>
              <div class="col-lg-4 alignmob"><p class="content-center" style="padding-top: 15px;">
                <a href="" target="_blank">Made with <span style="color: #e74c3c">♥</span> in India</a>. </p>
              </div>
              <div class="col-lg-3 alignmob">
                <a href="https://www.facebook.com/HireClap"><i class="mdi mdi-facebook mdi-footer" style="font-size:24px;"></i></a>
                <a href="https://twitter.com/Hireclap"><i class="mdi mdi-twitter mdi-footer" style="font-size:24px;"></i></a>
                <a href="https://www.linkedin.com/company/hireclap"><i class="mdi mdi-linkedin mdi-footer" style="font-size:24px;"></i></a>
                <a href="https://www.youtube.com/channel/UC_Rhjfe3TniDTGLn8nxcu0Q"><i class="mdi mdi-youtube mdi-footer" style="font-size:24px;"></i></a>
                <a href="https://www.instagram.com/hireclap"><i class="mdi mdi-instagram mdi-footer" style="font-size:24px;"></i></a>
              </div>
            </div>
          </div>    
        </div>
        <!--footer end-->
      </div>
    </section>
  </div>
</template>

<script>
export default ({
  name: "private_job_description",
  props:['id','type','user_id'],
  data(){
    return{
      vue_app_url : process.env.VUE_APP_URL,
      validate: new this.$valid(),
      jobDetails: null,
      job:null,
      courses:[],
      cities:[],
      jobrole:null,
      applied:false,
      job_type:[
          {value:1, text:'Full time'},
          {value:2, text:'Work from home'},
          {value:3, text:'Hybrid'},
          {value:4, text:'Part time'},
          {value:5, text:'Internship'},
          {value:6, text:'Apprenticeship'},
      ],
      exp:[
            { value: 1, text: "0 Month(Fresher)" },
            { value: 2, text: "06 Months" },
            { value: 3, text: "1 Year" },
            { value: 4, text: "2 year" },
            { value: 5, text: "3 year" },
            { value: 6, text: "4 year" },
            { value: 7, text: "5 year" },
            { value: 8, text: "6 year" },
            { value: 9, text: "6+ year" },
      ],
      c_job_type:null,
    }
  },
  beforeMount(){
    this.getJobDetails();
    window.scrollTo(0,0);
  },
  methods:{
    getJobDetails(){
      new this.$apiAction().getJobDetails({id:this.id,type:this.type, user_id:this.user_id}).then(res => {
        this.jobDetails=res.data;
        this.job = res.data.jobs;
        this.getCourse();
        this.getCities();
        this.getJobrole();
        this.getJobType();
      });
    },
    getCourse(){
      new this.$apiAction().getCourse().then((data) => {
        data.courses.forEach(course => {
          this.jobDetails.courses.forEach(c => {
            if(course.course_id == c){
              this.courses.push(course)
            }
          })
        })
      })
    },
    getCities(){
        new this.$apiAction().getStates().then((data) => {
          this.jobDetails.cities.forEach(city => {
            data.states.forEach(state => {
              state.cities.forEach(c => {
                if(c.city_id == city){
                  this.cities.push(c)
                }
              })
            })
          })
        })
    },
    getJobrole(){
      new this.$apiAction().getJobrole().then(res => {
        res.jobroles.forEach(role => {
          if(role.role_id == this.jobDetails.jobs.job_role){
            this.jobrole = role
          }
        })
      })
    },
    getJobType(){
      this.job_type.forEach(type => {
        if(type.value == this.jobDetails.jobs.job_type){
          this.c_job_type = type.text;
        }
      })
    },
    newTab(url){
       if (!url.match(/^https?:\/\//i)) {
        url = 'https://' + url;
      }
      window.open(url, '_blank').focus();
    },
    getStatus(status) {
        switch(status) {
            case 0: return 'Pending'; 
            case 1: return 'Active'; 
            case 2: return 'Inactive'; 
            case 3: return 'Rejetced'; 
            case 4: return 'Deleted'; 
            case 5: return 'Archived'; 
            case 6: return 'on hold'; 
            default: break;
        }
    },
    convertTimestamp(data){
      var months = {'01':'Jan', '02':'Feb' , '03':'Mar' , '04':'Apr' , '05':'May' , '06':'June' , '07':'July' , '08':'Aug' , '09':'Sep' , '10':'Oct' , '11':'Nov' , '12':'Dec' , };
      var post_ms = data*1000
      var date_ob = new Date(post_ms)
      var year = date_ob.getFullYear();
      var month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
      var date = ("0" + date_ob.getDate()).slice(-2);
      var result = date+'th-'+months[month]+'-'+year;
      return result;
    },
    getJobExp(exp1, exp2){
      var display_exp = ''
      var experienceFrom = ''
      var experienceTo = ''
      
      if(exp1 == 0){
        experienceFrom="0";
      }else if(exp1 > 0 && exp1 < 12 ){	
        experienceFrom = exp1+" Months";
      }else{		
        experienceFrom=(exp1 / 12)+" Years";
      }		

      if(exp2 == 0){	
        experienceTo="0";		
      }else if(exp2 > 0 && exp2 < 12 ){		
        experienceTo= exp2+" Months";		
      }		
      else if(exp2 == 84){		
        experienceTo="6+";
      }else{		
        experienceTo=(exp2 / 12)+" Years";	
      }

      if(experienceFrom == "0" && experienceTo == "0"){		
        display_exp= "";
      }
      else if(exp2 == exp1){		
        display_exp = experienceTo;	
      }		
      else{		
        display_exp= experienceFrom+" to "+experienceTo;		
      }
      return display_exp;
    },
  }
})
</script>